import { render, staticRenderFns } from "./DateVencimientoModal.vue?vue&type=template&id=5ad0770e&"
import script from "./DateVencimientoModal.vue?vue&type=script&lang=ts&"
export * from "./DateVencimientoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports